var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ShProgressBar"},[_c('div',{staticClass:"ShProgressBar__bar",style:({backgroundColor: _vm.getLighterColor(), borderBottomColor: _vm.getDarkenColor(), width: _vm.dynamicWidth, height: _vm.height })})])}
var staticRenderFns = []

export { render, staticRenderFns }